var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: ["collapsible-item", _vm.variant] },
    [
      _c(
        "div",
        { staticClass: "collapsible-header", on: { click: _vm.toggle } },
        [
          _vm.variant === "created"
            ? _c("span", { staticClass: "collapsible-icon" }, [_vm._v("+")])
            : _c("b-icon", {
                staticClass: "section-icon",
                attrs: { icon: _vm.headerIcon },
              }),
          _c("span", { staticClass: "collapsible-text" }, [
            _vm._v(" " + _vm._s(_vm.headerText) + " "),
          ]),
          _vm.tooltip
            ? _c("b-icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true },
                  },
                ],
                staticClass: "tooltip-icon",
                attrs: { title: _vm.tooltip, icon: "question-circle-fill" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              })
            : _vm._e(),
          _c("b-icon", {
            staticClass: "chevron-icon",
            attrs: { icon: _vm.show ? "chevron-up" : "chevron-down" },
          }),
        ],
        1
      ),
      _c("b-collapse", { attrs: { visible: _vm.show } }, [
        _c("div", { staticClass: "collapsible-content" }, [
          _vm.items.length > 0
            ? _c(
                "div",
                { staticClass: "items-list" },
                _vm._l(_vm.items, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: _vm.variant + "-" + index,
                      staticClass: "detail-item",
                    },
                    [_vm._t("item", null, { item: item, index: index })],
                    2
                  )
                }),
                0
              )
            : _c("p", { staticClass: "no-items" }, [
                _vm._v(_vm._s(_vm.$t("nenhumitem"))),
              ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }